<div class="wrapper">
  <div id="npshChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #npshChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>NPSH graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>
    </div>
  }
</div>